import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledCountSection = styled.div`
    position: relative;
    overflow: hidden;
    padding: 120px 0;

    .second_item {
        position: relative;
        z-index: 999;

        .counter_bottom {
            padding-left: ${props => props.offset ? props.offset + 'px' : '90px'};
            padding-right: ${props => props.offset ? props.offset + 'px' : '90px'};

            .content_large {
                h3 {
                    color: ${theme.colors.secondaryGreenTop};
                    ${theme.counterLarge}
                }

                h5 {
                    color: ${theme.colors.white};
                    margin: 0 0 70px;
                    ${theme.fontGroup24}
                }

                p {
                    ${theme.mainTitle500}
                    color: ${theme.colors.white};
                    margin: 0;
                }

                .link-only {
                    ${theme.LinkOnly}
                }
            }


            .custom-counter-row {
                gap: 50px;

                .counter_bottom_single {
                    padding: 0;
                }

                .col-md-6 {
                    ${theme.flex50}
                }

                ${devices.sm} {
                    padding: 0 15px;
                    margin-top: 0;
                    justify-content: space-between;
                    gap: 0;

                    .col-md-6 {
                        ${theme.flex50}
                    }
                }
            }


            ${devices.sm} {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
        }
    }

    ${devices.md} {
        padding: 95px 0;

        .col-md-4 {
            width: 100%;
        }

        .col-md-6 {
            width: 100%;
            margin-left: 0;
            margin-top: 30px;
        }
    }

    ${devices.sm} {
        .subHeading {
            margin-bottom: 0 !important;
        }
    }

}`
